import React from 'react';

const STYLES = {
  'In Queue': { background: '#e8f0fe', color: '#1a73e8' },
  'In Production': { background: '#e8f5e9', color: '#2e7d32' },
  'Ready to Ship': { background: '#fff3e0', color: '#e65100' },
  'Delivered': { background: '#e0f2f1', color: '#00695c' },
  'On Hold': { background: '#fce4ec', color: '#c62828' },
  'Delivered / Need Invoice': { background: '#f3e5f5', color: '#6a1b9a' },
  'Need To Be Filled/Started': { background: '#fff9c4', color: '#827717' },
};

export default function StatusBadge({ status }) {
  const s = STYLES[status] || { background: '#eee', color: '#555' };
  return <span className="badge" style={s}>{status}</span>;
}

export const STATUSES = Object.keys(STYLES);
export const MACHINES = ['Greenwood', 'Mini FFG', 'Partition Slotter', 'Slitter', 'Flatbed Die Cutter', 'Clamshell Die Cutter', 'Digital Printer', 'Bandsaw', 'Gluing Station', 'Assembly Station'];
export const MATERIAL_STATUSES = ['Need To Be Ordered', 'Ordered', 'Material Received', 'Stock Sheets', 'Done'];
